import LogChangesTable from "@/common/components/LogChangesTable";
import { CompanyData } from "@/features/companies/types/companies.type";
import { ClientEquipmentConsumptionHistory } from "@/features/privateCompanies/components/showEquipment/consumptionHistory";
import { EquipmentData } from "@/features/privateCompanies/components/showEquipment/equipmentData";
import { FipeData } from "@/features/privateCompanies/components/showEquipment/fipeData";
import { ClientEquipmentLastUsageDeclarationsPerCategory } from "@/features/privateCompanies/components/showEquipment/lastUsageDeclarationsPerCategory";
import type { CompanyEquipmentData } from "@/features/privateCompanies/types/companyEquipments.type";

export const companyEquipmentsTabs = (equipment?: CompanyEquipmentData, equipmentId?: string, company?: CompanyData) => [
  {
    label: 'Dados',
    value: '',
    body: <EquipmentData equipmentId={equipmentId} equipment={equipment} />,
  },
  {
    label: 'Histórico de Uso',
    value: 'lastUsageDeclarationsPerCategory',
    body: <ClientEquipmentLastUsageDeclarationsPerCategory equipment={equipment} />,
    operationKlassToCheckPermission: 'Admin::Client::Equipments::LastUsageDeclarationsPerCategoryFilter',
  },
  {
    label: 'Histórico de transações',
    value: 'consumptionHistory',
    body: <ClientEquipmentConsumptionHistory
      company={company}
      equipment={equipment}
    />,
  },
  {
    label: 'Histórico de mudanças',
    value: 'changeHistory',
    body: <LogChangesTable type="ClientEquipment" id={equipmentId} />,
  },
  {
    label: 'Dados FIPE',
    value: 'fipeData',
    body: <FipeData id={equipment?.model?.id} />,
    operationKlassToCheckPermission: 'Admin::EquipmentModels::LatestFipe'
  }
]
